import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="button-state"
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.buttonTarget.disabled = true
  }

  enable() {
    this.buttonTarget.disabled = false
  }
}
